import React from 'react';
import { cn } from '../../lib/utils';

interface DropdownDividerProps {
  className?: string;
}

export function DropdownDivider({ className = '' }: DropdownDividerProps) {
  return <div className={cn('h-px bg-gray-200 my-1', className)} role="separator" />;
}
